export default class BusinessReferralPayoutTO {
  /**
   * @type {number}
  */
  businessId = undefined;

  /**
   * @type {number}
  */
  stateId = undefined;

  /**
   * @type {string}
  */
  checkNumber = undefined;

  /**
   * @type {number}
  */
  checkAmount = undefined;

  constructor(opts = null) {
    if (opts != null) {
      if (opts.businessId != null) {
        this.businessId = opts.businessId;
      }
      if (opts.stateId != null) {
        this.stateId = opts.stateId;
      }
      if (opts.checkNumber != null) {
        this.checkNumber = opts.checkNumber;
      }
      if (opts.checkAmount != null) {
        this.checkAmount = opts.checkAmount;
      }
    }
  }
}
